import React, { useRef } from 'react';
import { Layout } from 'antd';
const { Footer } = Layout;
import { Translate } from 'app/services';
import { ACTIVE_BRAND_CONFIG, IS_HOYA_THEME, IS_SEIKO_THEME } from '../../branding';
import './styles.less';
import { getTranslatedString } from '../../services/translationService/components/Translate';
import { useAuthState } from '../../hooks/auth';
import { TermsAndConditions } from '../termsAndConditions';
import { useTranslations } from '../../hooks/translations/useTranslations';

export const AppFooter = ( ) => {

    const tnc = useRef( null );
    const { claims } = useAuthState();
    const { locale } = useTranslations();

    return (
        <Footer>
            <span onClick={ () =>
                locale === 'de-DE'
                    ? window.open( 'https://www.hoyavisionhub.com/de-de/de-portal/kontaktformular/', '_newtab' ) 
                    : window.location = `mailto:${ ACTIVE_BRAND_CONFIG.metadata.contactEmail }`
                }
            >
                <Translate.Text value="footer.contactUs" />
            </span>
            
            <span onClick={ () => window.open( IS_HOYA_THEME ? getTranslatedString( 'privacyNotice.link.hoya' ) : getTranslatedString( 'privacyNotice.link.seiko' ), '_newtab' ) }>
                <Translate.Text value="footer.privacyNotice" />
            </span>
        
            <span onClick={ () => window.open( getTranslatedString( 'privacyPolicy.link' ), '_newtab' ) }>
                <Translate.Text value="footer.privacyPolicy" />
            </span> 

            { !IS_SEIKO_THEME && claims.locale != 'de-DE' &&
                <span onClick={ () => tnc?.current.openTerms() }>
                    <TermsAndConditions cancellable ref={ tnc } termsFilter={ t => t.type == 'BUNCHBALL_ANON_USER' } />
                    <Translate.Text value="gamification.term" />
                </span>
            }
        </Footer>
    );
};